import React, { useEffect, useState } from 'react';
import Layout from '../components/Layout';
import { getContacts, markAsRead } from '../services/api';

export default function Contacts() {
  const [contacts, setContacts] = useState([]);
  const [loading, setLoading]   = useState(true);
  const [selected, setSelected] = useState(null);
  const [filter, setFilter]     = useState('all');

  useEffect(() => {
    getContacts()
      .then(data => { setContacts(data || []); setLoading(false); })
      .catch(() => setLoading(false));
  }, []);

  const handleRead = async (id) => {
    await markAsRead(id);
    setContacts(contacts.map(c => c._id === id ? { ...c, isRead: true } : c));
    if (selected?._id === id) setSelected({ ...selected, isRead: true });
  };

  const filtered = filter === 'all' ? contacts : filter === 'unread' ? contacts.filter(c => !c.isRead) : contacts.filter(c => c.isRead);

  return (
    <Layout>
      <div style={{ marginBottom: 24 }}>
        <h2 style={{ fontWeight: 800, color: '#0A1628', margin: '0 0 4px' }}>Enquiries</h2>
        <p style={{ color: '#888', fontSize: 14, margin: 0 }}>{contacts.filter(c => !c.isRead).length} unread of {contacts.length} total</p>
      </div>

      <div style={{ display: 'flex', gap: 8, marginBottom: 20 }}>
        {['all', 'unread', 'read'].map(f => (
          <button key={f} onClick={() => setFilter(f)} style={{ padding: '8px 18px', borderRadius: 10, border: 'none', fontSize: 13, fontWeight: 600, cursor: 'pointer', background: filter === f ? '#0066FF' : '#fff', color: filter === f ? '#fff' : '#555', boxShadow: filter === f ? '0 4px 12px rgba(0,102,255,0.25)' : '0 2px 8px rgba(0,0,0,0.05)' }}>
            {f.charAt(0).toUpperCase() + f.slice(1)}
          </button>
        ))}
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: selected ? '1fr 1fr' : '1fr', gap: 20 }}>
        {/* List */}
        <div style={{ background: '#fff', borderRadius: 16, border: '1.5px solid #eef0f8', overflow: 'hidden' }}>
          {loading ? (
            <p style={{ padding: '32px', textAlign: 'center', color: '#aaa' }}><i className="fa fa-spinner fa-spin me-2"></i>Loading...</p>
          ) : filtered.length === 0 ? (
            <p style={{ padding: '32px', textAlign: 'center', color: '#aaa' }}>No enquiries found</p>
          ) : filtered.map((c, i) => (
            <div key={c._id} onClick={() => { setSelected(c); if (!c.isRead) handleRead(c._id); }}
              style={{ padding: '16px 20px', borderBottom: i < filtered.length - 1 ? '1px solid #f5f5f5' : 'none', cursor: 'pointer', background: selected?._id === c._id ? '#f0f5ff' : c.isRead ? '#fff' : '#fffbf0', transition: 'all .15s' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                <div style={{ flex: 1 }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 4 }}>
                    {!c.isRead && <span style={{ width: 8, height: 8, borderRadius: '50%', background: '#ef4444', flexShrink: 0, display: 'inline-block' }}></span>}
                    <span style={{ fontSize: 14, fontWeight: 700, color: '#0A1628' }}>{c.name}</span>
                    <span style={{ fontSize: 11, color: '#aaa' }}>{c.type}</span>
                  </div>
                  <div style={{ fontSize: 13, fontWeight: 600, color: '#555', marginBottom: 3 }}>{c.subject}</div>
                  <div style={{ fontSize: 12, color: '#aaa', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', maxWidth: 280 }}>{c.message}</div>
                </div>
                <div style={{ fontSize: 11, color: '#bbb', flexShrink: 0, marginLeft: 12 }}>{new Date(c.createdAt).toLocaleDateString()}</div>
              </div>
            </div>
          ))}
        </div>

        {/* Detail */}
        {selected && (
          <div style={{ background: '#fff', borderRadius: 16, border: '1.5px solid #eef0f8', padding: '24px', height: 'fit-content' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
              <h5 style={{ fontWeight: 700, color: '#0A1628', margin: 0 }}>Message Detail</h5>
              <button onClick={() => setSelected(null)} style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#aaa', fontSize: 18 }}>
                <i className="fa fa-times"></i>
              </button>
            </div>
            <div style={{ marginBottom: 16 }}>
              {[{ label: 'From', value: selected.name }, { label: 'Email', value: selected.email }, { label: 'Subject', value: selected.subject }, { label: 'Type', value: selected.type }, { label: 'Date', value: new Date(selected.createdAt).toLocaleString() }].map((f, i) => (
                <div key={i} style={{ display: 'flex', gap: 12, marginBottom: 10 }}>
                  <span style={{ fontSize: 12, fontWeight: 700, color: '#aaa', width: 60, flexShrink: 0 }}>{f.label}</span>
                  <span style={{ fontSize: 13, color: '#0A1628', fontWeight: 600 }}>{f.value}</span>
                </div>
              ))}
            </div>
            <div style={{ background: '#f8faff', borderRadius: 12, padding: '16px', marginBottom: 16 }}>
              <p style={{ fontSize: 14, color: '#555', lineHeight: 1.7, margin: 0 }}>{selected.message}</p>
            </div>
            <a href={`mailto:${selected.email}`} style={{ display: 'inline-flex', alignItems: 'center', gap: 8, padding: '10px 20px', borderRadius: 10, background: '#0066FF', color: '#fff', fontWeight: 600, fontSize: 13, textDecoration: 'none' }}>
              <i className="fa fa-reply"></i> Reply via Email
            </a>
          </div>
        )}
      </div>
    </Layout>
  );
}
